import React, { Component } from 'react';
import cx from 'classnames';
import { setPopUp } from 'actions/environment';
import { connect } from 'react-redux';
import { ROOT_URL } from 'constants/Config.js';
import axios from 'axios';

import PayForTarif from '../PayForTarif';
import s from './style';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';

@connect(null, { setPopUp })
class PayForTarifBtn extends Component {
  payForTarif = async () => {
    this.props.onClick && this.props.onClick();
    const response = await axios.post(`${ROOT_URL}/user/payment/create`, { tariffId: 1 });
    const { orderId } = response.data.data;
    const { setPopUp } = this.props;
    tracker.sendEvent('Web_Profile_Renew_Subscription');

    axios.post(`${ROOT_URL}/payments`).then(response => {
      setPopUp(
        <PayForTarif
          url={response.data.data.confirmationUrl}
          orderNumber={orderId}
        />
        ,
        { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false }
      );
    }).catch(e => {
      setPopUp(<PayForTarif url={null} orderNumber={orderId} />, { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
    });
  }

  render() {
    const { className, t } = this.props;
    const classes = cx(className, s.root, 'button-primary', 'button-primary--lg');
    return (
      <button className={classes} onClick={this.payForTarif}>
        {this.props.children || t('components.payments.payForTarif.button')}
      </button>
    );
  }
}

export default withTranslation()(PayForTarifBtn);



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarifBtn/PayForTarifBtn.js